import React from "react";
import { Col, Container, Row, Table } from "reactstrap";
import { ReactComponent as Rupees } from "../../../../images/currency-rupee.svg";
import { numberToWords } from "../../CRM-Calicut/utils/numberWords";

const PrintBill = React.forwardRef(
  (
    {
      data,
      address = {},
      invoice_id = "",
      date,
      invoiceSheet = [],
      total = 0,
      payment_mode = "",
      branch = "",
      netAmountPay = 0,
      GSTIN = "",
      discount = 0,
      receivedAmt = 0,
      balanceAmount = 0,
      totalQTY = 0,
      totalTax = 0,
      taxableData = [],
      formData = {},
      branchData = {},
    },
    ref
  ) => {
    // Helper to format currency values safely
    const formatCurrency = (amount) => {
     
      const num = Number(amount) || 0;
      return num.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    };
    
    // Safe Date Parsing
    const printDate = date ? (
      <span style={{ fontSize: "10px" }}>
        {`${new Date(date).getDate()} / ${
          new Date(date).getMonth() + 1
        } / ${new Date(date).getFullYear()}`}
      </span>
    ) : null;

    // Billing details fallbacks
    const patientName = data?.otData?.fname || formData?.patientName || "";
    const contactNo = data?.otData?.contactno || formData?.contactNo || "";

    return (
      <Container className="p-3 pt-2">
        <style>
          {`
            @media print {
              body {
                -webkit-print-color-adjust: exact !important;
                print-color-adjust: exact !important;
              }
              .print-container {
                border: 1px solid #000 !important;
                margin: 0 !important;
                padding: 10px !important;
                width: 100% !important;
              }
              .bg-table-header {
                background-color: #D8D6D6 !important;
              }
            }
            .bill-table {
              border: 1px solid #000;
              border-collapse: collapse;
              width: 100%;
            }
            .bill-table th {
              border: 1px solid #000;
              padding: 4px 6px;
              font-size: 11px;
            }
            .bill-table td {
              border-right: 1px solid #000;
              padding: 4px 6px;
              font-size: 11px;
            }
            .bill-table td:last-child {
              border-right: none;
            }
            .bg-table-header {
              background-color: #D8D6D6;
            }
          `}
        </style>

        <div
          ref={ref}
          className="print-container"
          style={{ border: "solid thin black", padding: "15px" }}
        >
       {/* Header Section */}
<Row className="mx-0 pt-3 pb-3 align-items-center" style={{ borderBottom: "1px solid black" }}>
  {/* Left Column: Logo & Contact Details */}
  <Col
    md={3}
    sm={3}
    xs={3}
    className="d-flex flex-column align-items-start pe-2"
    style={{ textAlign: "left", fontSize: "10px", lineHeight: "1.35", color: "#222" }}
  >
    {branchData?.logoUrl && (
      <div className="mb-2">
        <img
          src={branchData.logoUrl}
          alt="Clinic Logo"
          className="img-fluid"
          style={{
            maxHeight: "75px",
            width: "auto",
            objectFit: "contain",
            display: "block",
          }}
        />
      </div>
    )}

    <div><b>GSTIN:</b> {GSTIN}</div>
    <div><b>Mobile:</b> {branchData?.contactNo}</div>
  </Col>

  {/* Center Column: Fully Centered Address Block */}
  <Col
    md={6}
    sm={6}
    xs={6}
    className="text-center px-2"
  >
    <div
      style={{
        color: "rgb(139, 15, 122)",
        fontSize: "17px",
        fontWeight: "bold",
        lineHeight: "1.2",
        letterSpacing: "0.5px",
        marginBottom: "4px",
      }}
    >
      {address?.first_line}
    </div>

    <div style={{ fontSize: "10px", lineHeight: "1.35", color: "#222" }}>
      {address?.second_line && <div>{address.second_line}</div>}
      <div>
        {address?.third_line}
        {address?.fourth_line ? `, ${address.fourth_line}` : ""}
      </div>
    </div>
  </Col>

  {/* Right Column: Tax Invoice Details (Right Aligned) */}
  <Col
    md={3}
    sm={3}
    xs={3}
    className="d-flex flex-column align-items-end ps-2"
    style={{ fontSize: "10px", textAlign: "right", lineHeight: "1.4" }}
  >
    <div className="fw-bold" style={{ fontSize: "13px", letterSpacing: "0.5px" }}>
      TAX INVOICE
    </div>

    <div
      className="d-inline-block px-2 py-1 my-1"
      style={{
        border: "1px solid #666",
        color: "#444",
        fontSize: "8px",
        fontWeight: "bold",
        textTransform: "uppercase",
      }}
    >
      Original For Recipient
    </div>

    <div><b>Invoice No:</b> {invoice_id}</div>
    <div style={{ whiteSpace: "nowrap" }}>
      <b>Date:</b> {printDate}
    </div>
  </Col>
</Row>

       {/* Billing / Shipping Details */}
<Row
  className="d-flex justify-content-between px-3 px-md-4 py-3"
  style={{ fontSize: "11px" }}
>
  <Col sm={6} xs={6} className="pe-2" style={{ textAlign: "left" }}>
    <div><b>BILL TO:</b> {patientName}</div>
    <div><b>Contact No:</b> {contactNo}</div>
  </Col>

  <Col sm={6} xs={6} className="ps-2" style={{ textAlign: "left" }}>
    <div><b>SHIP TO:</b> {patientName}</div>
  </Col>
</Row>

{/* Line Items Table */}
<Row className="d-flex justify-content-center">
  <Col className="px-3 px-md-4">
    <Table className="bill-table mb-0">
      <thead>
        <tr className="bg-table-header text-center">
          <th style={{ width: "8%" }}>SL No.</th>
          <th style={{ width: "40%" }}>ITEM/SERVICES</th>
          <th style={{ width: "10%" }}>QTY</th>
          <th style={{ width: "15%" }}>RATE</th>
          <th style={{ width: "10%" }}>TAX</th>
          <th style={{ width: "17%" }}>AMOUNT</th>
        </tr>
      </thead>
      <tbody>
        {invoiceSheet.map((rowObj, index) => {
          const rowData = rowObj[`Row${index + 1}`] || rowObj;
          const hasItem = Boolean(rowData?.item);

          const cgst = parseFloat(rowData.cgst || 0);
          const sgst = parseFloat(rowData.sgst || 0);
          const taxper = (cgst + sgst).toFixed(2);

          const rowBorderStyle = {
            borderBottom: hasItem ? "1px solid black" : "none",
          };

          return (
            <tr key={index} style={{ fontSize: "11px" }}>
              <td className="text-center" style={rowBorderStyle}>
                {hasItem ? index + 1 : ""}
              </td>
              <td className="text-start" style={rowBorderStyle}>
                {rowData.item || ""}
              </td>
              <td className="text-center" style={rowBorderStyle}>
                {rowData.qty || ""}
              </td>
              <td className="text-end" style={rowBorderStyle}>
                {rowData.rate ? formatCurrency(rowData.rate) : ""}
              </td>
              <td className="text-end" style={rowBorderStyle}>
                {rowData.tax ? (
                  <div>
                    <div>{formatCurrency(rowData.tax)}</div>
                    <div style={{ fontSize: "9px" }}>({taxper}%)</div>
                  </div>
                ) : (
                  ""
                )}
              </td>
              <td className="text-end" style={rowBorderStyle}>
                {rowData.amount ? formatCurrency(rowData.amount) : ""}
              </td>
            </tr>
          );
        })}

        {/* Summary Rows */}
        <tr className="bg-table-header fw-bold" style={{ borderTop: "1px solid black", borderBottom: "1px solid black" }}>
          <td colSpan={2} className="text-end">
            TOTAL
          </td>
          <td className="text-center">{totalQTY}</td>
          <td></td>
          <td className="text-center">{formatCurrency(totalTax)}</td>
          <td className="text-end">
            <Rupees style={{ maxWidth: "11px", maxHeight: "11px", marginRight: "2px" }} />
            {formatCurrency(total)}
          </td>
        </tr>
        <tr style={{ borderBottom: "1px solid black" }}>
          <td colSpan={5} className="text-end fw-bold">
            Discount
          </td>
          <td className="text-end">
            <Rupees style={{ maxWidth: "11px", maxHeight: "11px", marginRight: "2px" }} />
            {formatCurrency(discount)}
          </td>
        </tr>
        <tr style={{ borderBottom: "1px solid black" }}>
          <td colSpan={5} className="text-end fw-bold">
            Net Amount Payable
          </td>
          <td className="text-end fw-bold">
            <Rupees style={{ maxWidth: "11px", maxHeight: "11px", marginRight: "2px" }} />
            {formatCurrency(netAmountPay)}
          </td>
        </tr>
        <tr style={{ borderBottom: "1px solid black" }}>
          <td colSpan={5} className="text-end fw-bold">
            Received Amount
          </td>
          <td className="text-end">
            <Rupees style={{ maxWidth: "11px", maxHeight: "11px", marginRight: "2px" }} />
            {formatCurrency(receivedAmt)}
          </td>
        </tr>
        <tr style={{ borderBottom: "1px solid black" }}>
          <td colSpan={5} className="text-end fw-bold">
            Balance Amount
          </td>
          <td className="text-end">
            <Rupees style={{ maxWidth: "11px", maxHeight: "11px", marginRight: "2px" }} />
            {formatCurrency(balanceAmount)}
          </td>
        </tr>
      </tbody>
    </Table>
  </Col>
</Row>
 
{/* Tax Breakdown Table */}
<Row className="d-flex justify-content-center mt-3">
  <Col>
    <Table className="bill-table mb-0">
      <thead>
        <tr className="bg-table-header text-center">
          <th rowSpan={2} style={{ verticalAlign: "middle" }}>HSN/SAC</th>
          <th rowSpan={2} style={{ verticalAlign: "middle" }}>Taxable Value</th>
          <th colSpan={2}>CGST</th>
          <th colSpan={2}>SGST</th>
          <th rowSpan={2} style={{ verticalAlign: "middle" }}>Total Tax Amount</th>
        </tr>
        <tr className="bg-table-header text-center">
          <th>Rate</th>
          <th>Amount</th>
          <th>Rate</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(taxableData) && taxableData.filter(item => (parseFloat(item?.cgst) || 0) > 0 || (parseFloat(item?.sgst) || 0) > 0).length > 0 ? (
          taxableData
            .filter(item => (parseFloat(item?.cgst) || 0) > 0 || (parseFloat(item?.sgst) || 0) > 0)
            .map((item, id) => {
              const taxableVal = parseFloat(item?.taxableVal || 0);
              const cgst = parseFloat(item?.cgst || 0);
              const sgst = parseFloat(item?.sgst || 0);

              // ✅ Use the exact aggregated total tax, splitting cleanly into half for CGST and SGST
              const totalTaxAmt = parseFloat(item?.totalTaxAmt || 0);
              const cgstAmt = Number((totalTaxAmt / 2).toFixed(2));
              const sgstAmt = Number((totalTaxAmt - cgstAmt).toFixed(2)); // Ensures sum matches totalTaxAmt precisely without rounding gaps (e.g. 14.01 split handles odd/even cents perfectly)

              return (
                <tr key={id} className="text-end" style={{ fontSize: "11px", borderBottom: "1px solid black" }}>
                  <td className="text-center">{item?.hsn || "-"}</td>
                  <td>{formatCurrency(taxableVal)}</td>
                  <td>{cgst}%</td>
                  <td>{formatCurrency(cgstAmt)}</td>
                  <td>{sgst}%</td>
                  <td>{formatCurrency(sgstAmt)}</td>
                  <td>{formatCurrency(totalTaxAmt)}</td>
                </tr>
              );
            })
        ) : (
          <tr>
            <td colSpan={7} className="text-center" style={{ fontSize: "11px", borderBottom: "1px solid black" }}>
              No tax breakdown available
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </Col>
</Row>
 <Row className="px-3">
            <Col sm={3} style={{ maxWidth: "150px", fontSize: "11px" }}>
              Payment Mode - {payment_mode}
            </Col>
            <Col md="3" sm={2} style={{ fontSize: "11px" }}></Col>
          </Row>
          <Row className="d-flex justify-content-center">
            <Col>
              <Table bordered>
                <tbody>
                  <tr style={{ fontSize: "11px", textAlign: "left" }}>
                    <td
                      colSpan={2}
                      style={{
                        borderBottom: "solid thin #D8D6D6",
                        borderTop: "solid thin #D8D6D6",
                      }}
                    >
                      <b>
                        Total Amount (in Words) - {numberToWords(receivedAmt)}{" "}
                        Rupees
                      </b>
                    </td>
                  </tr>
                  <tr style={{ fontSize: "11px" }}>
                    <td
                      width={"50%"}
                      style={{
                        borderBottom: "solid thin #D8D6D6",
                        borderTop: "solid thin #D8D6D6",
                      }}
                    >
                      <b>Notes</b>
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        verticalAlign: "bottom",
                        height: "70px",
                        fontSize: "11px",

                        borderBottom: "solid thin #D8D6D6",
                        borderTop: "solid thin #D8D6D6",
                      }}
                    >
                      Authorised Signatory For <br />
                      {branchData?.LegalName}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="px-3">
            <Col style={{ fontSize: "11px", textAlign: "left" }}>
              This is a computer-generated invoice. No signature is required.
            </Col>
            <Col style={{ fontSize: "11px" }} md={3} sm={3}>
             Billed By: {data?.otData?.createdBy || data?.createdBy || ""}
            </Col>
          </Row>
          <Row className="px-3">
            <Col
              className="mt-3"
              style={{ fontSize: "11px", textAlign: "left" }}
            >
              <p>
                <b>Terms and Conditions</b>
              </p>
              <p className="bill-terms">
                1. Once sold, medicines can be exchanged within 15 days. No
                refund of payments.
              </p>
              <p className="mt-0">
                2. All disputes are subject to {`${branchData?.name}`}{" "}
                jurisdiction only
              </p>
            </Col>
          </Row>
        </div>
      </Container>
    );
  }
);

PrintBill.displayName = "PrintBill";

export default PrintBill;